import React from 'react'
import { Container, Col, Row } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTv, faGlobe, faUsers, faHeart } from '@fortawesome/free-solid-svg-icons'
import myimg from '../../assets/img/ytvlogo.png'
import './about.css'
import about from '../../assets/img/slides/Abouts.png'

const About = () => {
  return (
    <>
      <Helmet>
        <title>About YorkeTV | About Yorke TV</title>
        <meta name="description" content="YorkTV Is the cord to link Africans and the continent's friends and partners in the UK and Europe to the African continent. " />
        <meta name="keywords" content="YorkeTV, Channel 7, First Digital, Ghana TV, Papa Nduom, Kweku Anaisie" />
        <meta name="author" content="Groupe Nduom Station Based In UK" />
        <link rel="canonical" href="https://www.yorketv.com/about" />
      </Helmet>

      {/* Hero Section */}
      <div className='about-hero-section' style={{ backgroundImage: `url(${about})` }}>
        <div className='about-hero-overlay'>
          <div className='d-flex justify-content-center align-items-center h-100'>
            <div className='text-white text-center'>
              <h6 className='about-hero-subtitle'>Our Story</h6>
              <h1 className='about-hero-title'>About YorkeTV</h1>
              <p className='about-hero-description'>
                Connecting Africans and friends across the UK and Europe to the African continent
              </p>
            </div>
          </div>
        </div>
      </div>

      <Container className='about-container'>
        {/* Main Content Section */}
        <Row className='about-content g-4'>
          <Col xs={12} lg={5} className='about-image-col'>
            <div className='about-image-wrapper'>
              <img src={myimg} className='about-img' alt='YorkeTV Logo' />
            </div>
          </Col>
          <Col xs={12} lg={7} className='about-text-col'>
            <div className='about-text-section'>
              <h2 className='about-main-title'>About YorkeTV</h2>
              <p className='about-main-description'>
                YorkeTV is the cord to link Africans and the continent's friends and partners in the UK and Europe to the African continent. We are dedicated to providing quality television content that bridges cultures and connects communities.
              </p>
            </div>
          </Col>
        </Row>

        {/* Mission & Vision Section */}
        <Row className='about-mission-vision g-4'>
          <Col xs={12} md={6} className='mission-col'>
            <div className='mission-card'>
              <div className='mission-icon'>
                <FontAwesomeIcon icon={faTv} />
              </div>
              <h3 className='mission-title'>Our Mission</h3>
              <p className='mission-description'>
                To provide television content that is relevant to and promotes the needs and aspirations of the people in London and Ghana. We strive to be the bridge that connects African communities across borders.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} className='vision-col'>
            <div className='vision-card'>
              <div className='vision-icon'>
                <FontAwesomeIcon icon={faGlobe} />
              </div>
              <h3 className='vision-title'>Our Vision</h3>
              <p className='vision-description'>
                To become the leading platform for African content in the UK and Europe, fostering cultural exchange and celebrating the rich heritage of the African continent.
              </p>
            </div>
          </Col>
        </Row>

        {/* Values Section */}
        <Row className='about-values'>
          <Col xs={12}>
            <div className='values-section'>
              <h2 className='values-title'>What We Stand For</h2>
              <Row className='g-4'>
                <Col xs={12} sm={6} md={3}>
                  <div className='value-card'>
                    <div className='value-icon'>
                      <FontAwesomeIcon icon={faUsers} />
                    </div>
                    <h4 className='value-name'>Local Content</h4>
                    <p className='value-description'>
                      We document local festivals and events, bringing a unique local flavor to our content.
                    </p>
                  </div>
                </Col>
                <Col xs={12} sm={6} md={3}>
                  <div className='value-card'>
                    <div className='value-icon'>
                      <FontAwesomeIcon icon={faHeart} />
                    </div>
                    <h4 className='value-name'>Community</h4>
                    <p className='value-description'>
                      Building strong connections between African communities in the UK, Europe, and Africa.
                    </p>
                  </div>
                </Col>
                <Col xs={12} sm={6} md={3}>
                  <div className='value-card'>
                    <div className='value-icon'>
                      <FontAwesomeIcon icon={faGlobe} />
                    </div>
                    <h4 className='value-name'>Cultural Bridge</h4>
                    <p className='value-description'>
                      Connecting cultures and promoting understanding between different communities.
                    </p>
                  </div>
                </Col>
                <Col xs={12} sm={6} md={3}>
                  <div className='value-card'>
                    <div className='value-icon'>
                      <FontAwesomeIcon icon={faTv} />
                    </div>
                    <h4 className='value-name'>Quality Content</h4>
                    <p className='value-description'>
                      Delivering high-quality television programming that entertains, educates, and inspires.
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default About
